import { usePortal } from "../state/PortalContext";
import { Icon } from "./Icon";

export function ToastStack() {
  const { toasts, dismissToast } = usePortal();
  return (
    <div
      className="pointer-events-none fixed right-4 top-4 z-[100] flex w-[min(92vw,380px)] flex-col gap-3"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="pointer-events-auto animate-xp-pop rounded-2xl border border-slate-700 bg-slate-950/95 p-4 shadow-2xl backdrop-blur-xl"
        >
          <div className="flex items-start gap-3">
            <span
              className={`rounded-xl p-2 ${
                toast.tone === "success"
                  ? "bg-emerald-400/15 text-emerald-300"
                  : toast.tone === "warning"
                    ? "bg-amber-400/15 text-amber-300"
                    : "bg-indigo-400/15 text-indigo-300"
              }`}
            >
              <Icon
                name={
                  toast.tone === "success"
                    ? "Trophy"
                    : toast.tone === "warning"
                      ? "ShieldAlert"
                      : "Sparkles"
                }
                size={20}
              />
            </span>
            <div className="min-w-0 flex-1">
              <p className="font-display font-bold text-white">{toast.title}</p>
              <p className="mt-1 text-xs leading-5 text-slate-400">{toast.detail}</p>
            </div>
            <button
              onClick={() => dismissToast(toast.id)}
              className="rounded-lg p-1 text-slate-500 hover:bg-slate-800 hover:text-white"
              aria-label="Dismiss notification"
            >
              <Icon name="X" size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
